/** @jsxImportSource @emotion/react */
import CloseIcon from "@mui/icons-material/Close";
import { css, Dialog, DialogActions, IconButton } from "@mui/material";
import { VFC } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineWarning } from "react-icons/ai";
import { CountryPath } from "src/entities/CountryPath";
import getCountryName from "src/utils/getCountryName";
import Button from "../common/Button";

interface Props {
  open: boolean;
  handleClose: () => void;
  country: CountryPath;
  changeCountry: () => void;
}

const ChangeCountryModal: VFC<Props> = (props: Props) => {
  const [t] = useTranslation();
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <div className="p-4">
        <div style={{ textAlign: "right" }}>
          <IconButton onClick={props.handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="text-base whitespace-pre-line text-black pt-4 pb-4">
          {t("modal.change_country.title")}
          <b>{getCountryName(props.country)}</b>
          {` ?`}
          <div css={dialogCaution}>
            <AiOutlineWarning size="28px" style={{ marginRight: 8 }} />
            {`${t("modal.change_country.message")} ${getCountryName(
              props.country
            )} ${t("modal.change_country.message_end")}`}
          </div>
        </div>
        <DialogActions>
          <Button
            text={t("modal.change_country.button.cancel")}
            onClick={props.handleClose}
          />
          <Button
            text={t("modal.change_country.button.ok")}
            onClick={() => {
              props.changeCountry();
            }}
          />
        </DialogActions>
      </div>
    </Dialog>
  );
};

const dialogCaution = css`
  display: flex;
  font-size: 14px;
  align-items: center;
  margin-top: 12px;
  color: #808080;
  white-space: initial;
`;

export default ChangeCountryModal;
